<template>
  <div>
    <div class="report-container" v-if="engineer">
      <table class="table is-fullwidth">
        <tr>
          <th>Employee ID</th>
          <td>{{ engineer.employeeId }}</td>
          <th>Name</th>
          <td>{{ engineer.name }}</td>
        </tr>
        <tr>
          <th>Mobile</th>
          <td>{{ engineer.mobile }}</td>
          <th>Email</th>
          <td>{{ engineer.email }}</td>
        </tr>
        <tr>
          <th>From</th>
          <td>{{ $route.query.from | date }}</td>
          <th>To</th>
          <td>{{ $route.query.to | date }}</td>
        </tr>
        <tr>
          <th>Total Days</th>
          <td>{{ totalDays }}</td>
          <th>Leave Days</th>
          <td>{{ leaveDays }}</td>
        </tr>
        <tr>
          <th>Services Assigned</th>
          <td>{{ services.length }}</td>
          <th>Services Completed</th>
          <td>{{ servicesCompleted }}</td>
        </tr>
      </table>

      <div class="columns">
        <div class="column">
          <h1 class="is-size-4">Working vs Leavs Days</h1>
          <chart-pie
            id="leaves-chart"
            :slices="[workingDays, leaveDays]"
            :labels="['Working', 'Leaves']"
            colors="teal,coral"
          ></chart-pie>
        </div>
        <div class="column">
          <h1 class="is-size-4">Services Pending vs Completed</h1>
          <chart-pie
            id="services-chart"
            :slices="[servicesPending, servicesCompleted]"
            :labels="['Pending', 'Completed']"
            colors="coral,teal"
          ></chart-pie>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/http";
import moment from "moment";
import ChartPie from "../../components/chart-pie";
export default {
  components: {
    ChartPie
  },
  data() {
    return {
      engineer: null,
      leaves: [],
      services: []
    };
  },
  computed: {
    totalDays() {
      let component = this;
      return moment(component.$route.query.to).diff(
        moment(component.$route.query.from),
        "days"
      );
    },
    workingDays() {
      let component = this;
      return component.totalDays - component.leaveDays;
    },
    leaveDays() {
      let component = this;
      let days = 0;
      component.leaves.forEach(leave => {
        days += moment(leave.endDate).diff(moment(leave.startDate), "days");
      });

      return days;
    },
    servicesCompleted() {
      let component = this;
      let count = 0;
      component.services.forEach(service => {
        if (service.status === "completed") {
          count++;
        }
      });
      return count;
    },
    servicesPending() {
      let component = this;
      return component.services.length - component.servicesCompleted;
    }
  },
  mounted() {
    let component = this;
    component.$store.commit("setNavVisible", false);
    http
      .post(`/report/engineer/show/${component.$route.params.id}`, {
        from: component.$route.query.from,
        to: component.$route.query.to
      })
      .then(response => {
        component.engineer = response.data.engineer;
        component.leaves = response.data.leaves;
        component.services = response.data.services;
      });
  }
};
</script>
